import { DailyRecurrenceDetails, Recurrence, RecurrenceMode, RecurrenceType, StaticInitializers } from '@tableau/self-service-schedules';
import { ISchedule } from '../ServerApi/types/ISchedule';

export interface IScheduleInfo extends ISchedule {
  contentType: 'schedule';
}

export namespace IScheduleInfo {
  export function toRecurrence(schedule: IScheduleInfo): Recurrence {
    // SSS expects both Hourly and Daily schedules to have recurrenceDaysOfWeek to be set. In the Admin Schedules these schedule
    // types did not have those values set, and that was interpretted to mean "every day of the week"
    if ((schedule.scheduleType === RecurrenceType.Hourly || schedule.scheduleType === RecurrenceType.Daily) && !('recurrenceDaysOfWeek' in schedule.scheduleDetails)) {
      (schedule.scheduleDetails as DailyRecurrenceDetails).recurrenceDaysOfWeek = StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK;
    }
    const recurrence: Recurrence = {
      recurrenceDetails: schedule.scheduleDetails as any,
      recurrenceMode: RecurrenceMode.TimeRecurrence,
      recurrenceType: schedule.scheduleType as RecurrenceType,
    };
    return recurrence;
  }
}
